export default __webpack_public_path__ + "static/media/typeArrow.c383f7f3.c383f7f3.svg";